import Material from "./Material";
import apiSvgMaterialSchema from "../../services/bimVisualizerApi/schema/material/apiSvgMaterialSchema";
import MaterialTypeEnum from "../../enums/MaterialTypeEnum";

export default class SvgMaterial extends Material {

    url: string;

    constructor(materialId: number, url: string) {
        super(MaterialTypeEnum.SvgMaterial, materialId);
        this.url = url;
    }

    static fromJSON(json: any): SvgMaterial {
        const parsed = apiSvgMaterialSchema.parse(json);
        return new SvgMaterial( parsed.id, parsed.url);
    }
}